import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import state from './state'
import sidebarStore from '@/modules/attendance/store/sidebar'
import historyStore from '@/modules/attendance/store/history'
import filesModal from '@/modules/attendance/store/filesModal'

const attendanceStore = {
  namespaced: true,
  modules: {
    sidebarStore,
    historyStore,
    filesModal
  },
  state,
  getters,
  actions,
  mutations
}

export default attendanceStore
